import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Circle, Path, Rect } from './base/Icon';
import type { BaseIconProps } from './types';

/**
 * Private/local DB post avatar - lock icon (matches lucide Lock).
 * Pass color/bgColor for React Native; defaults use CSS vars (web).
 */
const PrivatePostAvatar: React.FC<BaseIconProps & {
  bgColor?: string;
}> = t0 => {
  const $ = _c(15);
  const {
    size: t1,
    width,
    height,
    color,
    bgColor
  } = t0;
  const size = t1 === undefined ? 40 : t1;
  const iconWidth = width || size;
  const iconHeight = height || size;
  const bg = bgColor || "rgba(var(--background-secondary-color))";
  const fg = color || "rgba(var(--primary))";
  let t2;
  if ($[0] !== bg) {
    t2 = <Circle cx="128" cy="128" r="128" fill={bg} />;
    $[0] = bg;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== fg) {
    t3 = <Path d="M96 116V92c0-17.7 14.3-32 32-32s32 14.3 32 32v24" stroke={fg} strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" fill="none" />;
    t4 = <Rect x="82" y="116" width="92" height="72" rx="12" stroke={fg} strokeWidth="12" fill="none" />;
    t5 = <Circle cx="128" cy="148" r="9" fill={fg} />;
    t6 = <Path d="M124 154h8v14h-8z" fill={fg} />;
    $[2] = fg;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== iconHeight || $[8] !== iconWidth || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <Icon width={iconWidth} height={iconHeight} viewBox="0 0 256 256" fill="none">{t2}{t3}{t4}{t5}{t6}</Icon>;
    $[7] = iconHeight;
    $[8] = iconWidth;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default PrivatePostAvatar;